import React from "react"
import { Row, Col } from "react-grid-system"
import TextButton from "../../atoms/buttons/TextButton"
import { HorizontalSpacer } from "../../atoms/spacers"
import H2 from "../../atoms/typography/H2"

const RelatedLinks: React.FunctionComponent<{ links: Record<string, string> }> = ({ links }) => {
  return (
    <div>
      <H2>Related links</H2>
      <HorizontalSpacer spacing={2} />
      <Row>
        {Object.entries(links).map(([name, url]) => (
          <Col key={url} xs="content">
            <TextButton title={name} onClick={() => window.open(url)} />
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default RelatedLinks
